import { Outlet } from 'react-router-dom'
import Header from './Header'
import Menu from './Menu'
import Footer from './Footer'

export default function Layout () {
  // eslint-disable-next-line react/react-in-jsx-scope
  return (<><Header/><Menu/><Outlet/><Footer/></>)
}
